<div
  class="notification-conponent-container"
  appScrollNearEnd
  (nearEnd)="onLoadMore($event)"
  (scrollingDown)="setIsScrollingDown($event)"
  [threshold]="0.95"
>
  <div class="list-header">
    <mat-icon class="primary-symbol xSmall">
      {{
        !notifications()?.length ? 'notifications_off' : 'notifications_active'
      }}
    </mat-icon>
    {{ 'notifications.notifications' | translate }}
  </div>

  @for (notification of notifications(); track notification.id) {
    <button mat-menu-item (click)="onPanelOpen(notification)">
      <div
        matBadge="."
        matBadgeSize="small"
        [matBadgeHidden]="notification.read"
      >
        {{ notification.headline | slice: 0 : 26 }}
        @if (notification.headline.length > 26) {
          <span>...</span>
        }

        @if (notification.read) {
          <div class="read-info">
            {{ 'common.read' | translate }}:
            {{ notification.read | date: 'shortDate' }}
          </div>
        }
      </div>
    </button>
  }
  @if (!notifications()?.length && !loading()) {
    <p>{{ 'notifications.no-notifications' | translate }}</p>
  }
  @if (loading()) {
    <div class="progress-container">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
